import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { useAuthentication } from "@/hooks/useAuthentication";
import { useSignOutWithPreviousRoute } from "@/hooks/usePreviousRoute";
import { getIsAuthenticated } from "@/lib/aws-amplify/auth";
import { insertToGA4DataLayer } from "@/lib/ga4-data-layer";

export const ProtectedRoutes = () => {
  const location = useLocation();
  const { account } = useAuthentication();
  const { signOutWithPreviousRoute } = useSignOutWithPreviousRoute();

  // route変更のたびに認証状態を確認
  // Location変更の度にfetchして確認する
  useEffect(() => {
    getIsAuthenticated()
      .then((isAuthenticated) => {
        if (!isAuthenticated) {
          throw new Error("not authenticated");
        }
      })
      .catch((error) => {
        console.error("not authenticated: ", error);
        signOutWithPreviousRoute();
      });
  }, [location, signOutWithPreviousRoute]);

  // GA4にユーザーIDを送信するための処理
  useEffect(() => {
    insertToGA4DataLayer(account.username);
  }, [account]);

  return <Outlet />;
};
